import { render, staticRenderFns } from "./VueFile.vue?vue&type=template&id=4507fc7a&"
import script from "./VueFile.vue?vue&type=script&lang=js&"
export * from "./VueFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports